import { SizeProp } from '@fortawesome/fontawesome-svg-core';
import { faSpinner } from '@fortawesome/free-solid-svg-icons/faSpinner';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

export default function Spinner({ color = 'black', size = '1x' }: { color?: string; size?: SizeProp }) {
	return <FontAwesomeIcon icon={faSpinner} color={color} size={size} spin />;
}
